import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap, takeUntil } from 'rxjs';

import { ViewsHttpService } from '../../services/views-http.service';
import { getFilterGroupId, ViewFilterGroupActions } from './filter-group.store';

@Injectable({ providedIn: 'root' })
export class FilterGroupEffects {
  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewFilterGroupActions.fetch),
      switchMap(({ payload: { dataSourceId, filterGroupId, query } }) =>
        this.viewsHttpService.fetchFilterGroup(dataSourceId, filterGroupId, query ?? {}).pipe(
          map(response =>
            ViewFilterGroupActions.fetchSuccess({
              payload: {
                data: { ...response, id: getFilterGroupId(dataSourceId, filterGroupId) },
              },
            }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              ViewFilterGroupActions.fetchFailed({
                payload: { error, id: getFilterGroupId(dataSourceId, filterGroupId) },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public fetchMore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewFilterGroupActions.fetchMore),
      mergeMap(({ payload: { dataSourceId, filterGroupId, query } }) =>
        this.viewsHttpService.fetchFilterGroup(dataSourceId, filterGroupId, query ?? {}).pipe(
          takeUntil(this.actions$.pipe(ofType(ViewFilterGroupActions.fetch))),
          map(response =>
            ViewFilterGroupActions.fetchMoreSuccess({
              payload: {
                data: { ...response, id: getFilterGroupId(dataSourceId, filterGroupId) },
              },
            }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              ViewFilterGroupActions.fetchMoreFailed({
                payload: { error, id: getFilterGroupId(dataSourceId, filterGroupId) },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private viewsHttpService: ViewsHttpService,
  ) {}
}
